import { CommonModule,CurrencyPipe,DatePipe } from '@angular/common';
import { AfterViewInit,Component,EventEmitter,Input,OnDestroy,Output } from '@angular/core';
import { FormControl,FormGroup,Validators } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyTableDataSource } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Actions,ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { BehaviorSubject,combineLatest,firstValueFrom,Observable,of,Subject,Subscription,switchMap } from 'rxjs';
import {distinctUntilChanged, map, skip, take, tap, withLatestFrom} from 'rxjs/operators';
import { LedgerImportDocumentTypeNames,LedgerImportDocumentTypeNumberLabel,LedgerImportDocumentTypes,LedgerImportEntity,LedgerImportStatusEnum,LedgerImportStatusNames } from '../dave-data-module/entities/ledger-import.entity';
import { ILedgerImportOptionalColumnsVisibility } from '../dave-data-module/entities/user.entity';
import { ViewStyleConfig } from '../dave-data-module/entities/viewStyleSetting.entity';
import { DaveMutationChangeLedgerImportArgs } from '../dave-data-module/graphql-types';
import { getFetched$ } from '../dave-data-module/helper/helper';
import { State } from '../dave-data-module/State';
import { LedgerImportActionTypes } from '../dave-data-module/State/actions/accounting.actions';
import { DaveActions } from '../dave-data-module/State/actions/actions';
import { BaseActionTypes } from '../dave-data-module/State/actions/base.actions';
import { ChangeSettings } from '../dave-data-module/State/actions/settings.actions';

import { ToastrService } from 'ngx-toastr';
import { getSetting, getSettingFetched, getUser } from '../dave-data-module/State/selectors/users.selectors';
import { DaveDoubleIconModule } from '../dave-double-icon/dave-double-icon.module';
import { ButtonConfig,MultiselectCardButton } from '../dave-list-card/dave-list-card.component';
import { DaveListCardModule } from '../dave-list-card/dave-list-card.module';
import { DaveLoadingModule } from '../dave-loading/dave-loading.module';
import { getLedgerImportStatusChangeMutationPayload } from '../dave-reports/components/arl-calculation/arl-calculation.helper';
import { AppButtonModule } from '../dave-utils-module/app-button-module/app-button.module';
import { AppConfirmationDialogComponent,AppConfirmationDialogData,AppConfirmationDialogReturnData } from '../dave-utils-module/app-dialog-module/app-confirmation-dialog/app-confirmation-dialog.component';
import { IDetailListTemplateData } from '../dave-utils-module/dave-shared-components-module/components/detail-views/detail-list-template/detail-list-template.component';
import { DaveSharedComponentsModule } from '../dave-utils-module/dave-shared-components-module/dave-shared-components.module';
import { PermissionService } from '../dave-utils-module/dave-shared-components-module/services/permission.service';
import { DaveHeaderHeight,isNotNullOrUndefined } from '../helper/helper';
import { AllReportsMeta,DMSPageMeta,InvoiceEditorMeta,ReportsPageMeta } from '../helper/page-metadata';
import { HintIconComponent } from '../hint-icon/hint-icon.component';
import { CustomLabelService } from '../services/custom-label/custom-label.service';
import { LoadingService } from '../services/loading.service';
import {LedgerImportDataService} from '../dave-data-module/services/ledger-import-data.service';

interface LedgerImportTableData {
    Id: number;
    ConsolidatedInvoiceId: string;
    Title: string;
    State: string;
    Customer: string;
    Sum: string;
    sortSum: number;
    DueDate: string;
    sortDueDate: number;
    CreatedAt: string;
    sortCreatedAt: number;
    Notes: string;
    suffixButton: ButtonConfig<LedgerImportTableData>;
    cssClass: string;
    DocumentId?: number;
    DocumentCanBeDownloaded: boolean;
    DocumentType: string;
}

type displayedColumn = keyof Omit<LedgerImportTableData, 'cssClass' | 'suffixButton'>;
const liInvoiceGroup = [LedgerImportDocumentTypes.Invoice, LedgerImportDocumentTypes.PartialInvoice, LedgerImportDocumentTypes.ClosingInvoice];

@Component({
    selector: 'app-ledger-import-list-card',
    standalone: true,
    imports: [CommonModule, MatExpansionModule, FontAwesomeModule, MatTabsModule, DaveListCardModule, DaveDoubleIconModule, MatMenuModule, AppButtonModule, MatTooltipModule, DaveSharedComponentsModule, DaveLoadingModule, HintIconComponent],
    templateUrl: './ledger-import-list-card.component.html',
    styleUrls: ['./ledger-import-list-card.component.scss'],
    providers: [CurrencyPipe, DatePipe],
})
export class LedgerImportListCardComponent implements AfterViewInit, OnDestroy {
    public currentTabIndex$ = new BehaviorSubject<number>(0);

    // public optionalColumnsVisibility: OptionalColumnsVisibilitySettings = {};
    private readonly DEFAULT_DISPLAYED_COLUMNS: displayedColumn[] = ['ConsolidatedInvoiceId', 'Title', 'State', 'Customer', 'Sum'];

    public DefaultSortActive: keyof LedgerImportTableData = 'CreatedAt';
    public DefaultSortDirection: 'desc' | 'asc' = 'desc';

    public HeaderHeight = DaveHeaderHeight;
    public showStatus: boolean = false;
    public multiselectAvailable: boolean = true;
    public customerLabel: string = '';
    public supplierLabel: string = '';
    public supplierLabelName: string[] = [LedgerImportDocumentTypeNames.get(LedgerImportDocumentTypes.Order), LedgerImportDocumentTypeNames.get(LedgerImportDocumentTypes.OrderConfirmation)];
    public StatusData$: Observable<IDetailListTemplateData>;
    public ReportListFormGroup = new FormGroup({
        Status: new FormControl<LedgerImportStatusEnum>(null, [Validators.required]),
    });
    public selectedEntryIds: Array<number> = [];
    public SaveClick$ = new Subject<void>();
    private ledgerImports$ = new BehaviorSubject<LedgerImportEntity[]>([]);
    @Input() set LedgerImports(v: LedgerImportEntity[]) {
        this.ledgerImports$.next(v || []);
    }
    @Input() view: Partial<ViewStyleConfig> = {};
    private _showCreateTeilrechnung$ = new BehaviorSubject(false);
    @Input() set ShowCreateTeilrechnung(v: boolean) {
        if (!!v !== this._showCreateTeilrechnung$.value) {
            this._showCreateTeilrechnung$.next(!!v);
        }
    }

    private _disableCreateTeilrechnungHint$ = new BehaviorSubject<string>('');
    @Input() set DisableCreateTeilrechnungHint(v: string) {
        if (v !== this._disableCreateTeilrechnungHint$.value) {
            this._disableCreateTeilrechnungHint$.next(v);
        }
    }
    private _disableCreateTeilrechnung$ = new BehaviorSubject(false);
    @Input() set DisableCreateTeilrechnung(v: boolean) {
        if (!!v !== this._disableCreateTeilrechnung$.value) {
            this._disableCreateTeilrechnung$.next(!!v);
        }
    }
    @Input() NavigateOnClick = false;
    @Input() ShowDocumentButton = true;
    /**
     * Represents an event emitter for document click events.
     * @param DocumentId
     */
    @Output() DocumentClick = new EventEmitter<number>();
    @Output() LedgerImportClick = new EventEmitter<{ entry: LedgerImportTableData; index: number; element: HTMLElement }>();
    @Output() NewLedgerImportClick = new EventEmitter<LedgerImportDocumentTypes | 'teilrechnung'>();
    private getLedgerImportsByDocTypes$ = (...documentTypes: LedgerImportDocumentTypes[]) => this.ledgerImports$.pipe(map((LedgerImports) => LedgerImports.filter((li) => documentTypes.includes(li.DocumentType))));

    private getLedgerImportListCardData$ = (ledgerImports$: Observable<LedgerImportEntity[]>) =>
        ledgerImports$.pipe(
            map((LedgerImports) => {
                const tableData = LedgerImports.map((b): LedgerImportTableData => {
                    return {
                        Id: b.Id,
                        ConsolidatedInvoiceId: b.ConsolidatedInvoiceId,
                        Sum: this.currencyPipe.transform((b.ConsolidatedNettoAmount || 0) / 100, b.ConsolidatedCurrencyCode),
                        sortSum: b.ConsolidatedNettoAmount,
                        DueDate: this.datePipe.transform(b.DueDate),
                        sortDueDate: b.DueDate ? b.DueDate.getTime() : null,
                        CreatedAt: this.datePipe.transform(b.CreatedAt),
                        sortCreatedAt: b.CreatedAt ? b.CreatedAt.getTime() : null,
                        Notes: b.AdditionalData?.notes,
                        Title: b.Title,
                        State: LedgerImportStatusNames.get(b.Status),
                        Customer: b.CustomerName,
                        DocumentId: b.DocumentId,
                        DocumentCanBeDownloaded: b.DocumentCanBeDownloaded,
                        suffixButton: b.DocumentId
                            ? {
                                  icon: DMSPageMeta.Icon,
                                  tooltip: 'Zum Dokument',
                                  hide: (args: LedgerImportTableData) => {
                                      return !args.DocumentId;
                                  },
                                  onClick: (args: LedgerImportTableData) => {
                                      if (args.DocumentCanBeDownloaded) {
                                          this.DocumentClick.emit(args.DocumentId);
                                      } else {
                                          this.toastrService.warning('Dieser Dokument kann noch nicht heruntergeladen werden.');
                                      }
                                  },
                              }
                            : null,
                        cssClass: b.GetBackgroundColorClass(),
                        DocumentType: b.DocumentType === LedgerImportDocumentTypes.PartialInvoice ? b.PartialInvoiceCounter + ". " + LedgerImportDocumentTypeNames.get(b.DocumentType) : LedgerImportDocumentTypeNames.get(b.DocumentType),
                    };
                }).sort((a, b) => (a.CreatedAt < b.CreatedAt ? 1 : -1));

                const datasource = new MatLegacyTableDataSource<LedgerImportTableData>(tableData);
                datasource.sortingDataAccessor = (o: Pick<LedgerImportTableData, displayedColumn>, key: displayedColumn) => {
                    switch (key) {
                        case 'CreatedAt':
                            return o.sortCreatedAt;
                        case 'DueDate':
                            return o.sortDueDate;
                        case 'Sum':
                            return o.sortSum;
                        case 'DocumentCanBeDownloaded':
                            return null;
                        default:
                            return o[key];
                    }
                };
                return datasource;
            }),
        );

    private columnSettings$ = getFetched$(this.store, getSettingFetched, getSetting).pipe(map((settings) => settings?.LedgerImportListOptionalDisplayedColumns));
    protected ledgerImportListData$: Observable<
        Array<{
            displayedColumns$: Observable<displayedColumn[]>;
            documentTypes: Array<{
                type: LedgerImportDocumentTypes | 'teilrechnung';
                label: string;
                disabledHint$: Observable<string>;
                loading$: Observable<boolean>;
                disabled$: Observable<boolean>;
            }>;
            documentTypeLabel: string;
            ListCardData$: Observable<MatLegacyTableDataSource<LedgerImportTableData>>;
        }>
    > = this._showCreateTeilrechnung$.pipe(
        map((showTeilrechnung) => {
            return [
                {
                    documentTypes: [
                        ...liInvoiceGroup.map((t) => ({
                            type: t,
                            label: LedgerImportDocumentTypeNames.get(t),
                            disabledHint$: of(''),
                            loading$: of(false),
                            disabled$: of(false),
                        })),
                        showTeilrechnung
                            ? {
                                type: 'teilrechnung' as LedgerImportDocumentTypes | 'teilrechnung',
                                label: 'Teilrechnung',
                                disabledHint$: this._disableCreateTeilrechnungHint$,
                                loading$: of(false),
                                disabled$: this._disableCreateTeilrechnung$,
                            }
                            : null,
                    ].filter(isNotNullOrUndefined),
                    documentTypeLabel: LedgerImportDocumentTypeNames.get(liInvoiceGroup[0]),
                },
                ...Array.from(LedgerImportDocumentTypeNames, ([val, key]) => ({
                    documentTypes: [
                        {
                            type: val,
                            label: key,
                            disabledHint$: of(''),
                            loading$: of(false),
                            disabled$: of(false),
                        },
                    ],
                    documentTypeLabel: key,
                })).filter((v) => !liInvoiceGroup.includes(v.documentTypes[0].type)),
            ].map((v) => ({
                ...v,
                ListCardData$: this.getLedgerImportListCardData$(this.getLedgerImportsByDocTypes$(...(v.documentTypes.filter((d) => d.type !== 'teilrechnung').map(d => d.type) as LedgerImportDocumentTypes[]))),
                displayedColumns$: this.columnSettings$.pipe(
                    map((columnSettings) => {
                        return [...this.DEFAULT_DISPLAYED_COLUMNS, ...getOptionalColumnsFromSettings(columnSettings, v.documentTypes[0].type as LedgerImportDocumentTypes)];
                    }),
                ),
            }));
        }),
    );
    currentDocumentType$ = this.ledgerImportListData$.pipe(switchMap((listData) => this.currentTabIndex$.pipe(map((index) => listData[index].documentTypes[0].type as LedgerImportDocumentTypes))));
    currentOptionalColumnsVisibility$: Observable<displayedColumn[]> = combineLatest([this.currentDocumentType$, this.columnSettings$]).pipe(
        map(([currentDocumentType, columnSettings]) => getOptionalColumnsFromSettings(columnSettings, currentDocumentType)),
    );
    private subscriptions: Subscription[] = [];
    constructor(
        private store: Store<State>,
        protected PS: PermissionService,
        public LS: LoadingService,
        protected cls: CustomLabelService,
        private dialog: MatDialog,
        private currencyPipe: CurrencyPipe,
        private datePipe: DatePipe,
        private actions$: Actions<DaveActions>,
        private toastrService: ToastrService,
        protected ledgerImportDataService: LedgerImportDataService
    ) {
        this.subscriptions.push(
            combineLatest([this.cls.getSingle$('CustomerSupplier'), this.cls.getSingle$('Supplier')]).subscribe(([customerSingleLabel, supplierSingleLabel]) => {
                this.customerLabel = customerSingleLabel;
                this.supplierLabel = supplierSingleLabel;
            }),
            this.ReportListFormGroup.controls.Status.valueChanges.pipe(distinctUntilChanged()).subscribe((value) => {
                console.log('Status changed:', value);
                if (!!value) {
                    this.SaveClick$.next();
                    this.showStatus = false;
                }
            }),
            this.SaveClick$.pipe(
                switchMap(() => this.ledgerImportDataService.getLedgerImportIds$(this.selectedEntryIds ?? [], true).pipe(take(1))),
            ).subscribe(( filteredInvoices) => {
                if (filteredInvoices?.length) {
                    this.LS.startLoading('reports-list-save-status');
                    filteredInvoices.forEach((i) => {
                        let values: DaveMutationChangeLedgerImportArgs = getLedgerImportStatusChangeMutationPayload(i, this.ReportListFormGroup.controls.Status.value);
                        this.store.dispatch(
                            LedgerImportActionTypes.ChangeLedgerImports({
                                Payload: values,
                            }),
                        );
                    });
                    this.actions$
                        .pipe(ofType(LedgerImportActionTypes.UpdateMany, BaseActionTypes.ErrorAction))
                        .pipe(skip(filteredInvoices.length - 1), take(1))
                        .subscribe((val) => {
                            this.LS.endLoading('reports-list-save-status');
                        });
                }
            }),
        );
    };


    ngAfterViewInit() {
            this.StatusData$ = combineLatest([
                this.ledgerImportDataService.getLedgerImportIds$(this.selectedEntryIds),
                this.PS.Has$(this.PS.Permissions.ChangeBusinessVolumeLedgerImportStatus)
            ]).pipe(
                map(([LedgerImports, isAdmin]) => {
                    let allStatus = Object.values(LedgerImportStatusEnum);
                    LedgerImports.forEach((li) => {
                        const availableStatus = li.AvailableStates(isAdmin);

                        allStatus = allStatus.filter((s) => availableStatus.find((a) => a.optionValue === s));
                });
                return {
                    Properties: [
                        {
                            key: 'Status',
                            formControl: this.ReportListFormGroup.controls.Status,
                            options: {
                                specialInput: {
                                    select: allStatus.map((as) => ({
                                        optionLabel: LedgerImportStatusNames.get(as),
                                        optionValue: as,
                                    })),
                                },
                            },
                        },
                    ],
                };
            }),
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());

        this.ledgerImports$.complete();
    }

    ArraySum(arr: Array<number>) {
        return arr.reduce((prev, curr) => (curr ? prev + curr : prev), 0);
    }
    GetRouteForLedgerImport = (ledgerImport: LedgerImportTableData) => ['/', ReportsPageMeta.Path, AllReportsMeta.Path, ledgerImport.Id];

    protected readonly InvoiceEditorMeta = InvoiceEditorMeta;
    protected readonly LedgerImportDocumentTypeNumberLabel = LedgerImportDocumentTypeNumberLabel;
    protected readonly LedgerImportDocumentTypeNames = LedgerImportDocumentTypeNames;

    protected readonly ReportsPageMeta = ReportsPageMeta;
    public MultiselectButtons$ = this.PS.Has$(this.PS.Permissions.DeleteAccountsReceivableLedgers).pipe(
        map((canDelete) => {
            const ret: MultiselectCardButton<any>[] = [];
            if (canDelete) {
                ret.push({
                    tooltip: 'Löschen',
                    icon: 'trash',
                    onClick: (entryIds, event) => {
                        return this.deleteSelected(entryIds as number[]);
                    },
                    color: 'red',
                });
            }
            return ret;
        }),
    );

    NewReport() {
        this.NewLedgerImportClick.emit(null);
    }

    getMatGroupTitle(title: string, count: number) {
        if (isNotNullOrUndefined(count)) {
            return title + ' (' + count + ')';
        } else {
            return title;
        }
    }

    getSelectedData(ids: Array<number | string>) {
        this.selectedEntryIds = ids as number[];
    }

    async deleteSelected(ids: number[]) {
        const selectedLedgers = await firstValueFrom(this.ledgerImportDataService.getLedgerImportIds$(ids));
        const deleteDeliveryNote = selectedLedgers.some((ledger) => ledger.DocumentType === LedgerImportDocumentTypes.DeliveryNote);

        const commissionLabel = await firstValueFrom(this.cls.getSingle$('Commission'));

        const dialogResponse = await firstValueFrom(
            this.dialog
                .open<AppConfirmationDialogComponent, AppConfirmationDialogData, AppConfirmationDialogReturnData>(AppConfirmationDialogComponent, {
                    data: {
                        paragraph: 'Ausgewählte Dokumente wirklich löschen?',
                        warning: deleteDeliveryNote ? 'Beim Löschen eines Lieferscheins werden die Materialverbräuche im ' + commissionLabel + ' angepasst.' : null,
                        styleDelete: true,
                    },
                })
                .afterClosed(),
        );
        if (dialogResponse && dialogResponse[0]) {
            ids.forEach((reportId) => {
                this.store.dispatch(
                    LedgerImportActionTypes.DeleteLedgerImport({
                        Payload: { id: reportId },
                    }),
                );
            });
        }
        return dialogResponse[0];
    }

    // /**
    //  * Initialisiert die Sichtbarkeit der optionalen Spalten für die Ledger-Import-Liste.
    //  * Lädt die gespeicherten Einstellungen für den entsprechenden Benutzer und aktualisiert die angezeigten Spalten entsprechend.
    //  * Falls keine Einstellungen vorhanden sind, werden die Standardwerte verwendet.
    //  * @private
    //  */
    // private async initOptionalColumnsVisibility() {
    //     const savedSettings = await this.loadOptionalColumnsVisibilityFromStore();
    //
    //     this.ledgerImportListData.forEach((type) => {
    //         const currentType = type.documentTypes[0] as LedgerImportDocumentTypes;
    //
    //         if (savedSettings && savedSettings[currentType]) {
    //             this.optionalColumnsVisibility[currentType] = savedSettings[currentType];
    //         } else {
    //             this.defaultOptionalColumnsVisibility(currentType);
    //         }
    //
    //         this.updateDisplayedColumns(currentType);
    //     });
    // }
    //
    // /**
    //  * Lädt die Sichtbarkeitseinstellungen der optionalen Spalten aus dem Store.
    //  * @private
    //  */
    // private async loadOptionalColumnsVisibilityFromStore() {
    //     return await firstValueFrom(
    //         getFetched$(this.store, getSettingFetched, getSetting).pipe(
    //             map((settings) => {
    //                 const columnSettings = settings?.LedgerImportListOptionalDisplayedColumns;
    //                 return columnSettings ? columnSettings : null;
    //             }),
    //         ),
    //     );
    // }
    //
    // /**
    //  * Setzt die Standard-Sichtbarkeit der optionalen Spalten für den angezeigten Dokumenten-Type.
    //  * @private
    //  */
    // private defaultOptionalColumnsVisibility(typeKey: LedgerImportDocumentTypes) {
    //     const showDueDate = this.showDueDateByDefault(typeKey);
    //     this.optionalColumnsVisibility = {
    //         ...this.optionalColumnsVisibility,
    //         [typeKey]: {
    //             Frist: showDueDate,
    //             ErstelltAm: !showDueDate,
    //             Notiz: false,
    //         },
    //     };
    // }
    //
    /**
     * Wechselt die Sichtbarkeit der angegebenen Spalte für den aktuellen Dokumenten-Type, der im Tab angezeigt wird.
     * Wenn die Spalte bereits sichtbar ist, wird sie ausgeblendet, andernfalls wird sie eingeblendet.
     * @param column optionale Spalten, die ein- und ausgeblendet werden können.
     */
    async updateColumn(column: displayedColumn, visible: boolean) {
        const currentType = await firstValueFrom(this.currentDocumentType$);
        const currentColumns = await firstValueFrom(this.currentOptionalColumnsVisibility$);
        const settings: ILedgerImportOptionalColumnsVisibility = {
            Frist: column === 'DueDate' ? !currentColumns.includes('DueDate') : currentColumns.includes('DueDate'),
            ErstelltAm: column === 'CreatedAt' ? !currentColumns.includes('CreatedAt') : currentColumns.includes('CreatedAt'),
            Notiz: column === 'Notes' ? !currentColumns.includes('Notes') : currentColumns.includes('Notes'),
            Dokumentenart: column === 'DocumentType' ? !currentColumns.includes('DocumentType') : currentColumns.includes('DocumentType'),
        };
        await this.saveOptionalColumnVisibilitySettings(currentType, settings);
    }

    /**
     * Callback für den Tab-Index-Wechsel.
     * @param tabIndex Der Index des aktuell ausgewählten Tabs.
     */
    onTabIndexChange(tabIndex: number) {
        this.currentTabIndex$.next(tabIndex);
    }

    // /**
    //  * Aktualisiert die angezeigten Spalten für den aktuellen Tab basierend auf der Sichtbarkeitseinstellung.
    //  * Fügt zu den Standardspalten optionale Spalten hinzu, wenn sie sichtbar sein sollten.
    //  * @param documentType Der aktuelle Dokument-Type der im Tab angezeigt wird und dessen Spalten aktualisiert werden sollen.
    //  */
    // updateDisplayedColumns(documentType: LedgerImportDocumentTypes) {
    //     const typeIndex = this.ledgerImportListData.findIndex((type) => type.documentTypes.includes(documentType));
    //
    //     if (typeIndex !== -1) {
    //         const optionalColumns: displayedColumn[] = [];
    //         if (this.optionalColumnsVisibility[documentType].Frist) optionalColumns.push('DueDate');
    //         if (this.optionalColumnsVisibility[documentType].ErstelltAm) optionalColumns.push('CreatedAt');
    //         if (this.optionalColumnsVisibility[documentType].Notiz) optionalColumns.push('Notes');
    //
    //         this.ledgerImportListData[typeIndex].displayedColumns = [...this.DEFAULT_DISPLAYED_COLUMNS, ...optionalColumns];
    //     }
    // }

    /**
     * Speichert die Sichtbarkeitseinstellungen der optionalen Spalten im Store.
     * Dispatched eine Aktion, um die Einstellungen zu aktualisieren.
     */
    private async saveOptionalColumnVisibilitySettings(type: LedgerImportDocumentTypes, columnSetting: ILedgerImportOptionalColumnsVisibility) {
        let currentSettings = await firstValueFrom(this.columnSettings$);
        if (!currentSettings) {
            currentSettings = {};
        }
        this.store.dispatch(
            new ChangeSettings({
                LedgerImportListOptionalDisplayedColumns: { ...currentSettings, [type]: columnSetting },
            }),
        );
    }


    protected getTableHeaderCollumsMap(type: {
        ListCardData$: Observable<MatLegacyTableDataSource<LedgerImportTableData>>;
        displayedColumns$: Observable<('Id' | 'ConsolidatedInvoiceId' | 'Title' | 'State' | 'Customer' | 'Sum' | 'sortSum' | 'DueDate' | 'sortDueDate' | 'CreatedAt' | 'sortCreatedAt' | 'Notes' | 'DocumentId' | 'DocumentCanBeDownloaded' | 'DocumentType')[]>;
        documentTypeLabel: string;
        documentTypes: {
            disabled$: Observable<boolean>;
            disabledHint$: Observable<string>;
            label: string;
            loading$: Observable<boolean>;
            type: LedgerImportDocumentTypes.Invoice
        }[]
    }) {
        if (type.documentTypes[0].type === LedgerImportDocumentTypes.Invoice || type.documentTypes[0].type === LedgerImportDocumentTypes.PartialInvoice || type.documentTypes[0].type === LedgerImportDocumentTypes.ClosingInvoice) {
            return {
                DocumentType: "Dokumentenart",
                ConsolidatedInvoiceId: LedgerImportDocumentTypeNumberLabel.get(type.documentTypes[0].type),
                Title: 'Titel',
                State:'Status',
                Customer: this.supplierLabelName.includes(type.documentTypeLabel) ? this.supplierLabel : this.customerLabel,
                Sum: 'Summe',
                DueDate: 'Frist',
                CreatedAt: 'Erstellt',
                Notes: 'Notiz',
            };
        }

        return {
            ConsolidatedInvoiceId: LedgerImportDocumentTypeNumberLabel.get(type.documentTypes[0].type),
            Title: 'Titel',
            State:'Status',
            Customer: this.supplierLabelName.includes(type.documentTypeLabel) ? this.supplierLabel : this.customerLabel,
            Sum: 'Summe',
            DueDate: 'Frist',
            CreatedAt: 'Erstellt',
            Notes: 'Notiz',
        };
    }
}

/**
 * Bestimmt, ob das Fälligkeitsdatum standardmäßig in der Tabelle als Spalte angezeigt werden soll.
 * @param currentType Der aktuelle Dokumenten-Type, der angezeigt wird (z.B. Rechnungen).
 * @private
 */
const showDueDateByDefault = (currentType: LedgerImportDocumentTypes) => {
    return currentType === LedgerImportDocumentTypes.Invoice || currentType === LedgerImportDocumentTypes.Offer || currentType === LedgerImportDocumentTypes.OfferConfirmation;
}

const getOptionalColumnsFromSettings = (columnSettings: Partial<Record<LedgerImportDocumentTypes, ILedgerImportOptionalColumnsVisibility>> | null, type: LedgerImportDocumentTypes) => {
    const optionalColumns: displayedColumn[] = []

    if (columnSettings && columnSettings[type]) {
        if (columnSettings[type].Frist) optionalColumns.push('DueDate');
        if (columnSettings[type].ErstelltAm) optionalColumns.push('CreatedAt');
        if (columnSettings[type].Notiz) optionalColumns.push('Notes');
        if (columnSettings[type].Dokumentenart) optionalColumns.push('DocumentType');
    } else {
        const showDueDate = showDueDateByDefault(type);
        if (showDueDate) {
            optionalColumns.push('DueDate');
        } else {
            optionalColumns.push('CreatedAt')
        }
    }
    return optionalColumns;
}
